import Select from "../select/Select";
import React from "react";
import "./SelectCustom.scss";
import { Form } from "antd";

const SelectCustom: React.FC<any> = ({handleChange, error, rtl, value, hint, maxLength, headingleft, className, name, rules, placeholder, options, form, ...props}) => {
    return (
        <div className={`${error?.length > 0 ? "error" : "normal"} mb-3`}>
            <div className='inputField__error d-flex flex-column'>
                <div className="d-flex align-items-center">
                <Form.Item
                    name={name}
                    rules={rules}
                    hasFeedback
                    className={`heading-section ${rtl ? 'rightDir' : ''}`}
                >
                    <Select
                        id={name}
                        placeholder={placeholder}
                        options={options}
                        rtl={rtl}
                        value={value}
                        onChange={handleChange}
                        {...props}
                    />
                </Form.Item>
                    {hint ? <div className='hint-tooltip' data-tooltip={hint} /> : <div className="gap-18"></div>}
                </div>
            </div>
        </div>
    )
}

export default SelectCustom;
